/**
 * Whether Readium 2 puts upgrade-insecure-requests in a chapter's CSP, as it
 * does by default. An http root is a local server, where WebKit would then get
 * no image or style over https. Readium's 'auto' would drop it for Fenice's
 * file:// root too.
 * @param {string|undefined} baseURL - The publication's root
 * @returns {'never'|'always'}
 */
export function upgradeInsecureRequestsFor(baseURL) {
    return baseURL?.startsWith('http:') ? 'never' : 'always';
}
